module.exports = __webpack_public_path__ + "img/toilet_seat.1d049182.svg";